<template>
    <div class="card-challenge-requests-rival-number">
        <h2 class="card-challenge-requests-rival-number__heading">Rakiplerinle yüzleş!</h2>
        <p class="card-challenge-requests-rival-number__desc">Tam <span class="card-challenge-requests-rival-number__num-rival">{{ numRival }}</span> kişi sana meydan okudu!</p>
        <span class="card-challenge-requests-rival-number__art"></span>
    </div>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        props: {
            numRival: {
                type: Number,
                default: 3,
            }
        }
    };
</script>

<style scoped src="@/css/components/card-challenge-requests-rival-number.css"></style>